$(() => {
  $('#developer_support_request_done_modal').modal('show');
});
